import { useQuery } from "@tanstack/react-query";
import { getExchangeRate, ExchangeRate } from "../services/exchangeRateService";

export const exchangeRateKeys = {
  all: ["exchange-rate"] as const,
};

/**
 * Hook to fetch USD to TJS exchange rate from our API
 * @returns Query result with exchange rate data
 */
export const useExchangeRate = () => {
  return useQuery<ExchangeRate | null>({
    queryKey: exchangeRateKeys.all,
    queryFn: () => getExchangeRate(),
    staleTime: 60 * 60 * 1000, // 1 hour - exchange rates don't change frequently
    retry: 1,
    refetchOnWindowFocus: false,
  });
};

